import React from 'react';
import { Button, Card, Container, Link, Typography } from '@sm/wds-react';
import { SummarySideBarSkeleton } from './SummarySideBarSkeleton';
import './summary-side-bar.scss';

export type SummarySideBarProps = {
  headline: string;
  message: string;
  image: () => React.ReactElement | null;
  ctaText: string;
  ctaLink: string;
  ctaNewTab?: boolean;
  loading?: boolean;
};

export const SummarySideBar: React.FC<SummarySideBarProps> = ({
  headline,
  message,
  image,
  ctaText,
  ctaLink,
  ctaNewTab,
  loading,
}) => {
  const ImageComponent = image;
  return (
    <>
      {loading ? (
        <SummarySideBarSkeleton />
      ) : (
        <Container flex flexDirection="column" mb={4} mt={4}>
          <Typography className="wds-m-b-3" variant="sectionTitle">
            {headline}
          </Typography>
          <Card>
            <Link
              data-testid="cta-image"
              href={ctaLink}
              target={ctaNewTab ? '_blank' : undefined}
              rel={ctaNewTab ? 'noreferrer noopener' : undefined}
            >
              <ImageComponent />
            </Link>
            <Typography className="wds-m-y-4" component="div" variant="body">
              {message}
            </Typography>
            <Button
              color="alt"
              href={ctaLink}
              target={ctaNewTab ? '_blank' : undefined}
              rel={ctaNewTab ? 'noreferrer noopener' : undefined}
              size="sm"
            >
              {ctaText}
            </Button>
          </Card>
        </Container>
      )}
    </>
  );
};

SummarySideBar.defaultProps = {
  ctaNewTab: false,
  loading: false,
};

export default SummarySideBar;
